<template>
    <div class="page-container custom-field-container">
        <h2 class="custom-field-title">
            自定义字段
        </h2>
        <!-- <lamp-tip local-key="tp.applet.index">
            <div class="lamptip-desc">
                <p>
                    功能说明
                </p>
            </div>
        </lamp-tip> -->
        <div class="custom-field-handle">
            <div class="custom-field-handle-left">
                <v-tip
                    ref="tips"
                    placement="top"
                    kind="small"
                    clazz="custom-field-handle-left-tip"
                >
                    <span>您历史创建的自定义字段(含已删除)已达上限，无法继续创建，如需帮助请联系企点客服。</span>
                </v-tip>
                <v-button
                    :disabled="pagination.total >= 1000"
                    kind="primary"
                    @click="open"
                >
                    <v-icon
                        remote
                        name="basic_new_line"
                    />
                    新建
                </v-button>
                <div
                    v-if="totalItems >= 1000"
                    v-tip:tips.hover
                    class="custom-field-handle-left-mask"
                />
            </div>
            <div class="custom-field-handle-right">
                <v-input
                    v-model="searchVal"
                    name="product"
                    kind="search"
                    placeholder="搜索"
                    width="160"
                    @search="search"
                />
                <div class="custom-field-handle-right-status">
                    <span>启用状态</span>
                    <v-select
                        v-model="selectedVal"
                        :options="statusList"
                        @select="selectChange"
                    />
                </div>
            </div>
        </div>
        <div>
            <v-table
                :data="tableData"
                :pagination="pagination"
                @paginationChange="paginationChange"
                @sort="sort"
            >
                <v-table-column
                    v-for="column in columns1"
                    :key="column.label"
                    :column-key="column.columnKey"
                    :label="column.label"
                    :sortable="column.sortable"
                    :width="column.width"
                />
                <v-table-column
                    label="字段类型"
                    column-key="type"
                    width="120"
                >
                    <template
                        slot="cell"
                        slot-scope="props"
                    >
                        <p>
                            {{ hanldeType(props.row.type) }}
                        </p>
                    </template>
                </v-table-column>
                <v-table-column
                    label="字段描述"
                    column-key="desc"
                    width="240"
                >
                    <template
                        slot="cell"
                        slot-scope="props"
                    >
                        <p>
                            {{ props.row.desc }}
                        </p>
                    </template>
                </v-table-column>
                <v-table-column
                    label="最近更新时间"
                    column-key="displayUpdateTime"
                    sortable
                    width="200"
                >
                    <template
                        slot="cell"
                        slot-scope="props"
                    >
                        <p>
                            {{ props.row.displayUpdateTime }}
                        </p>
                    </template>
                </v-table-column>
                <v-table-column
                    label="启用状态"
                    column-key="status"
                    sortable
                    width="120"
                >
                    <template
                        slot="cell"
                        slot-scope="props"
                    >
                        <p>
                            <span
                                :class="[
                                    props.row.status === 1 ?
                                        'custom-field-table-status-green' : 'custom-field-table-status-red'
                                ]"
                            />
                            {{ props.row.status === 1 ? '已启用' : '已停用' }}
                        </p>
                    </template>
                </v-table-column>
                <v-table-column
                    width="148"
                    align="center"
                >
                    <template
                        slot="cell"
                        slot-scope="props"
                    >
                        <v-button-group>
                            <v-popconfirm
                                :ref="`popconfirm_${props.row.id}`"
                                :use-arrow="false"
                                :footer-config="{
                                    primary: {
                                        text: '停用',
                                        kind: 'warning'
                                    },
                                    cancel: {
                                        text: '取消',
                                    }
                                }"
                                placement="bottom-end"
                                @confirm="handleData(props.row.id, 2)"
                            >
                                <span slot="header">确认停用吗？</span>
                                <div :style="{width: '288px', textAlign: 'left'}">
                                    停用后，您将无法继续使用该字段，历史数据仍会保留。
                                </div>
                            </v-popconfirm>
                            <v-button
                                v-if="props.row.status === 1"
                                v-popconfirm.clik="`popconfirm_${props.row.id}`"
                                type="link"
                                kind="primary"
                            >
                                停用
                            </v-button>
                            <v-button
                                v-if="props.row.status !== 1"
                                type="link"
                                kind="primary"
                                @click="handleData(props.row.id, 1)"
                            >
                                启用
                            </v-button>
                            <v-button
                                type="link"
                                kind="primary"
                                @click="handleEdit(props.row.id)"
                            >
                                编辑
                            </v-button>
                            <v-popconfirm
                                ref="popconfirmDel"
                                :use-arrow="false"
                                :footer-config="{
                                    primary: {
                                        text: '删除',
                                        kind: 'warning'
                                    },
                                    cancel: {
                                        text: '取消',
                                    }
                                }"
                                placement="bottom-end"
                                @confirm="handleData(props.row.id, 3)"
                            >
                                <span slot="header">确认删除吗？</span>
                                <div :style="{width: '288px', textAlign: 'left'}">
                                    删除后，您将无法继续使用该字段，且自定义字段列表中也不再展示。
                                </div>
                            </v-popconfirm>
                            <v-button
                                v-popconfirm:popconfirmDel
                                type="link"
                                kind="primary"
                            >
                                删除
                            </v-button>
                        </v-button-group>
                    </template>
                </v-table-column>
            </v-table>
        </div>

        <VmCustomPanel
            :id="id"
            :visible="visible"
            :edit="edit"
            @close="()=>{visible=false; edit=false}"
            @confirmCb="confirmCb"
        />
    </div>
</template>

<script>
import VmCustomPanel from '@/components/vm-custom-panel';
// import LampTip from 'src/components/lamp-tip';
export default {
    components: {
        VmCustomPanel,
        // LampTip,
    },
    data() {
        const columns = [
            {
                label: '字段名称',
                columnKey: 'name',
                width: 180,
                expandable: true,
            }, {
                label: '字段ID',
                columnKey: 'apiName',
                width: 240,
            }];
        return {
            visible: false,
            edit: false,
            id: 0,
            textList: [
                {
                    type: '单行文本',
                    value: 1,
                },
                {
                    type: '多行文本',
                    value: 2,
                },
                {
                    type: '日期',
                    value: 4,
                },
                {
                    type: '数值',
                    value: 3,
                },
                {
                    type: '下拉列表',
                    value: 6,
                },
                {
                    type: '单选',
                    value: 7,
                },
                {
                    type: '多选',
                    value: 8,
                },
            ],
            columns1: columns,
            tableData: [],
            pagination: {
                count: 15,
                index: 1,
                total: 100,
            },
            searchVal: '',
            selectedVal: 0,
            statusList: [
                {
                    text: '全部',
                    value: 0,
                },
                {
                    text: '已启用',
                    value: 1,
                },
                {
                    text: '已停用',
                    value: 2,
                },
            ],
            sortBy: '',
            sortMode: 0,
        };
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        // 获取列表数据
        getTableData() {
            this.$ajax.gatewayPost('/v1/common/userDefinedFields', {
                offset: this.pagination.index,
                limit: this.pagination.count,
                keyword: this.searchVal,
                filters: this.selectedVal ? [{ field: 'FStatus', op: '=', value: this.selectedVal.toString() }] : [],
                sortBy: this.sortBy ? [this.sortBy] : [0],
                sortMode: this.sortMode,
            }).then((res) => {
                if (res.data && res.data.items) {
                    this.tableData = res.data.items;
                }
                this.pagination.total = Number(res.data.total);
            });
        },
        // 翻页处理
        paginationChange(pageNum, pageSize) {
            this.pagination.count = pageSize;
            this.pagination.index = pageNum;
            this.getTableData();
        },
        // 打开抽屉
        open() {
            this.edit = false;
            this.visible = true;
            this.id = 0;
        },
        /**
         * @desc 处理tpe
         * @param {Number} type - 处理type
         */
        hanldeType(type) {
            let text = '';
            this.textList.forEach((item) => {
                if (item.value === type) {
                    text = item.type;
                }
            });
            return text;
        },
        /**
         * @desc 处理停用、启用、删除
         * @param {Number} id - id
         * @param {Number} status - 状态
         */
        handleData(id, status) {
            this.$ajax.gatewayPost('/v1/common/updateUserDefinedField', {
                id,
                status,
            }).then(() => {
                if (status === 1) {
                    this.$message.success('启用成功');
                } else if (status === 2) {
                    this.$message.success('停用成功');
                } else if (status === 3) {
                    this.pagination.index = 1;
                    this.$message.success('删除成功');
                }
                this.getTableData();
            });
        },
        handleEdit(id) {
            this.edit = true;
            this.id = id;
            this.visible = true;
        },
        sort(order, key) {
            this.sortMode = order === 'desc' ? 0 : 1;
            if (key === 'displayUpdateTime') this.sortBy = 2;
            if (key === 'status') this.sortBy = 3;
            this.getTableData();
        },
        search() {
            this.pagination.index = 1;
            this.getTableData();
        },
        selectChange(val) {
            this.selectedVal = val.value;
            this.getTableData();
        },
        confirmCb() {
            this.pagination.index = 1;
            this.getTableData();
        },
    },
};
</script>

<style lang="less" scoped>
.custom-field-title {
    margin: 16px 0;
    font-size: 20px;
    line-height: 28px;
    font-weight: 600;
    color: rgba(0, 1, 10, 0.93);
}
.custom-field-handle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    &-left {
        position: relative;
        &-mask {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
        }
    }
    &-right {
        display: flex;
        align-items: center;
        &-status {
            display: flex;
            align-items: center;
            > span {
                color: rgba(1, 11, 50, 0.41);
                margin-left: 10px;
                margin-right: 6px;
            }
        }
    }
}
.custom-field-table {
    &-status {
        &-green {
            display: inline-block;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: rgba(15, 184, 127, 1);
        }
        &-red {
            display: inline-block;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: rgba(247, 85, 89, 1);
        }
    }
}
</style>
<style>
.custom-field-handle-left-tip {
    width: 217px;
}
.custom-field-container .lamptip-content .lamptip-wrapper {
    margin-bottom: 16px;
}
</style>
